import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { 
    FaBed, FaBath, FaRulerCombined, FaHeart, FaRegHeart, 
    FaWhatsapp, FaPhoneAlt, FaMapMarkerAlt, FaArrowRight, 
    FaStar, FaChevronLeft, FaChevronRight
} from 'react-icons/fa';
import '../css/PropertyPage.css';

// Import local images (same as before)
import Property1Img1 from '../assets/Property1/1.jpeg';
import Property1Img2 from '../assets/Property1/2.jpeg';
import Property1Img3 from '../assets/Property1/3.jpeg';
import Property1Img4 from '../assets/Property1/4.jpeg';
import Property1Img5 from '../assets/Property1/5.jpeg';
import Property1Img6 from '../assets/Property1/6.jpeg';
import Property1Img7 from '../assets/Property1/7.jpeg';
import Property1Img8 from '../assets/Property1/8.jpeg';

import Property2Img1 from '../assets/Property2/1.jpeg';
import Property2Img2 from '../assets/Property2/2.jpeg';
import Property2Img3 from '../assets/Property2/3.jpeg';
import Property2Img4 from '../assets/Property2/4.jpeg';
import Property2Img5 from '../assets/Property2/5.jpeg';
import Property2Img6 from '../assets/Property2/6.jpeg';
import Property2Img7 from '../assets/Property2/7.jpeg';
import Property2Img8 from '../assets/Property2/8.jpeg';
import Property2Img9 from '../assets/Property2/9.jpeg';
import Property2Img10 from '../assets/Property2/10.jpeg';
import Property2Img11 from '../assets/Property2/11.jpeg';
import Property2Img12 from '../assets/Property2/12.jpeg';
import Property2Img13 from '../assets/Property2/13.jpeg';
import Property2Img14 from '../assets/Property2/14.jpeg';
import Property2Img15 from '../assets/Property2/15.jpeg';
import Property2Img16 from '../assets/Property2/16.jpeg';
import Property2Img17 from '../assets/Property2/17.jpeg';

import Property3Img1 from '../assets/Property3/1.jpeg';
import Property3Img2 from '../assets/Property3/2.jpeg';
import Property3Img3 from '../assets/Property3/3.jpeg';
import Property3Img4 from '../assets/Property3/4.jpeg';
import Property3Img5 from '../assets/Property3/5.jpeg';
import Property3Img6 from '../assets/Property3/6.jpeg';
import Property3Img7 from '../assets/Property3/7.jpeg';
import Property3Img8 from '../assets/Property3/8.jpeg';
import Property3Img9 from '../assets/Property3/9.jpeg';
import Property3Img10 from '../assets/Property3/10.jpeg';
import Property3Img11 from '../assets/Property3/11.jpeg';
import Property3Img12 from '../assets/Property3/12.jpeg';
import Property3Img13 from '../assets/Property3/13.jpeg';

import Property4Img1 from '../assets/Property4/1.jpeg';
import Property4Img2 from '../assets/Property4/2.jpeg';
import Property4Img3 from '../assets/Property4/3.jpeg';
import Property4Img4 from '../assets/Property4/4.jpeg';
import Property4Img5 from '../assets/Property4/5.jpeg';
import Property4Img6 from '../assets/Property4/6.jpeg';
import Property4Img7 from '../assets/Property4/7.jpeg';
import Property4Img8 from '../assets/Property4/8.jpeg';
import Property4Img9 from '../assets/Property4/9.jpeg';
import Property4Img10 from '../assets/Property4/10.jpeg';
import Property4Img11 from '../assets/Property4/11.jpeg';
import Property4Img12 from '../assets/Property4/12.jpeg';
import Property4Img13 from '../assets/Property4/13.jpeg';
import Property4Img14 from '../assets/Property4/14.jpeg';

const PropertyPage = () => {
    const navigate = useNavigate();
    const [activeCategory, setActiveCategory] = useState('all');
    const [likedProperties, setLikedProperties] = useState([]);
    const [currentImageIndex, setCurrentImageIndex] = useState({});

    const properties = [
        {
            id: 1,
            title: "The Royal Haven - Malad East",
            location: "Malad East, Mumbai",
            bedrooms: 3,
            bathrooms: 3,
            area: "950 sq ft",
            rating: 4.9,
            category: "malad",
            images: [
                Property1Img1, Property1Img2, Property1Img3, Property1Img4,
                Property1Img5, Property1Img6, Property1Img7, Property1Img8
            ],
            amenities: [
                "🛏 Bed", "🔐 Cupboard", "🌀 Air conditioner", "🧊 Fridge",
                "👕 Washing Machine", "🚿 Geyser", "💧 Aqua guard", "🔥 Gas Stove",
                "🚰 24 hours Water", "♨️ Microwave Oven", "📶 WiFi", "🧹 Housekeeping",
                "🖥️ study table", "🪑 chair"
            ],
            featured: true,
            bestDeal: true,
            description: "Experience unparalleled luxury at The Royal Haven. This premium girls' PG accommodation features elegant interiors, state-of-the-art amenities, and 24/7 personalized service.",
            address: "Pandit Solicitor Road, Opposite Blue Diamond, Malad East, Mumbai - 400097"
        },
        {
            id: 2,
            title: "The Grand Suite - Malad East",
            location: "Malad West, Mumbai",
            bedrooms: 3,
            bathrooms: 3,
            area: "940 sq ft",
            rating: 4.8,
            category: "malad",
            images: [
                Property2Img1, Property2Img2, Property2Img3, Property2Img4,
                Property2Img5, Property2Img6, Property2Img7, Property2Img8,
                Property2Img9, Property2Img10, Property2Img11, Property2Img12,
                Property2Img13, Property2Img14, Property2Img15, Property2Img16, Property2Img17
            ],
            amenities: [
                "🛏 Bed", "🔐 Cupboard", "🌀 Air conditioner", "🧊 Fridge",
                "👕 Washing Machine", "🚿 Geyser", "💧 Aqua guard", "🔥 Gas Stove",
                "🚰 24 hours Water", "♨️ Microwave Oven", "📶 WiFi", "🧹 Housekeeping",
                "🖥️ study table", "🪑 chair"
            ],
            featured: true,
            bestDeal: false,
            description: "Indulge in the finest living experience at The Grand Suite. This exquisite PG offers spacious deluxe rooms with premium furnishings, ensuite bathrooms, and breathtaking city views.",
            address: "Near Inorbit Mall, Malad West, Mumbai - 400064"
        },
        {
            id: 3,
            title: "The Executive Tower - Goregaon East",
            location: "Goregaon East, Mumbai",
            bedrooms: 3,
            bathrooms: 3,
            area: "925 sq ft",
            rating: 5.0,
            category: "goregaon",
            images: [
                Property3Img1, Property3Img2, Property3Img3, Property3Img4,
                Property3Img5, Property3Img6, Property3Img7, Property3Img8,
                Property3Img9, Property3Img10, Property3Img11, Property3Img12, Property3Img13
            ],
            amenities: [
                "🛏 Bed", "🔐 Cupboard", "🌀 Air conditioner", "🧊 Fridge",
                "👕 Washing Machine", "🚿 Geyser", "💧 Aqua guard", "🔥 Gas Stove",
                "🚰 24 hours Water", "♨️ Microwave Oven", "📶 WiFi", "🧹 Housekeeping",
                "🖥️ study table", "🪑 chair"
            ],
            featured: true,
            bestDeal: true,
            description: "Designed for the modern executive, this premium PG offers unmatched sophistication. Enjoy spacious rooms, dedicated workspace, premium bedding, and access to exclusive common areas.",
            address: "Near Oberoi Mall, Goregaon East, Mumbai - 400063"
        },
        {
            id: 4,
            title: "The Elite Residence - Goregaon East",
            location: "Goregaon West, Mumbai",
            bedrooms: 3,
            bathrooms: 3,
            area: "920 sq ft",
            rating: 4.9,
            category: "goregaon",
            images: [
                Property4Img1, Property4Img2, Property4Img3, Property4Img4,
                Property4Img5, Property4Img6, Property4Img7, Property4Img8,
                Property4Img9, Property4Img10, Property4Img11, Property4Img12, Property4Img13, Property4Img14
            ],
            amenities: [
                "🛏 Bed", "🔐 Cupboard", "🌀 Air conditioner", "🧊 Fridge",
                "👕 Washing Machine", "🚿 Geyser", "💧 Aqua guard", "🔥 Gas Stove",
                "🚰 24 hours Water", "♨️ Microwave Oven", "📶 WiFi", "🧹 Housekeeping",
                "🖥️ study table", "🪑 chair"
            ],
            featured: false,
            bestDeal: true,
            description: "Elevate your lifestyle at The Elite Residence. This meticulously curated PG offers the perfect blend of luxury and convenience. From designer interiors to world-class amenities.",
            address: "Link Road, Goregaon West, Mumbai - 400062"
        }
    ];

    // Auto-slide images for each property
    useEffect(() => {
        const intervals = {};
        
        properties.forEach(property => {
            intervals[property.id] = setInterval(() => {
                setCurrentImageIndex(prev => ({
                    ...prev,
                    [property.id]: ((prev[property.id] || 0) + 1) % property.images.length
                }));
            }, 4000);
        });
        
        return () => {
            Object.values(intervals).forEach(interval => clearInterval(interval));
        };
    }, []);

    const toggleLike = (id) => {
        if (likedProperties.includes(id)) {
            setLikedProperties(likedProperties.filter(item => item !== id));
        } else {
            setLikedProperties([...likedProperties, id]);
        }
    };

    const nextImage = (propertyId, totalImages) => {
        setCurrentImageIndex(prev => ({
            ...prev,
            [propertyId]: ((prev[propertyId] || 0) + 1) % totalImages
        }));
    };

    const prevImage = (propertyId, totalImages) => {
        setCurrentImageIndex(prev => ({
            ...prev,
            [propertyId]: ((prev[propertyId] || 0) - 1 + totalImages) % totalImages
        }));
    };

    const goToImage = (propertyId, index) => {
        setCurrentImageIndex(prev => ({
            ...prev,
            [propertyId]: index
        }));
    };

    const goToPropertyPage = (propertyId) => {
        navigate(`/property/${propertyId}`);
    };

    const filteredProperties = activeCategory === 'all' 
        ? properties 
        : properties.filter(prop => prop.category === activeCategory);

    const handleWhatsAppInquiry = (property) => {
        const message = `🏠 *PG INQUIRY* 🏠%0A%0A` +
            `━━━━━━━━━━━━━━━━━━━━━━%0A` +
            `✨ *Property:* ${property.title}%0A` +
            `📍 *Location:* ${property.location}%0A` +
            `🏠 *Area:* ${property.area}%0A` +
            `🛏️ *Bedrooms:* ${property.bedrooms}%0A` +
            `━━━━━━━━━━━━━━━━━━━━━━%0A` +
            `🌟 *I'm interested in this property. Please contact me!* 🌟`;
        
        window.open(`https://wa.me/918879779777?text=${encodeURIComponent(message)}`, '_blank');
    };

    const handleCallInquiry = () => {
        window.open('tel:+918879779777', '_blank');
    };

    return (
        <div className="prop-page-wrapper">
            {/* Simple Hero Section */}
            <div className="prop-hero-simple">
                <div className="prop-hero-simple-content">
                    <h1>Find Your <span>Perfect Stay</span></h1>
                    <p>Discover luxury living spaces in prime locations across Mumbai</p>
                </div>
            </div>

            {/* Category Filter */}
            <div className="prop-category-filter">
                <div className="prop-filter-container">
                    <button 
                        className={`prop-filter-btn ${activeCategory === 'all' ? 'active' : ''}`}
                        onClick={() => setActiveCategory('all')}
                    >
                        All Properties
                    </button>
                    <button 
                        className={`prop-filter-btn ${activeCategory === 'malad' ? 'active' : ''}`}
                        onClick={() => setActiveCategory('malad')}
                    >
                        Malad
                    </button>
                    <button 
                        className={`prop-filter-btn ${activeCategory === 'goregaon' ? 'active' : ''}`}
                        onClick={() => setActiveCategory('goregaon')}
                    >
                        Goregaon
                    </button>
                </div>
            </div>

            {/* Properties Grid */}
            <div className="prop-grid-container">
                <div className="prop-grid">
                    {filteredProperties.map((property) => (
                        <div className="prop-card" key={property.id}>
                            {/* Image Carousel */}
                            <div className="prop-card-image-carousel" onClick={() => goToPropertyPage(property.id)}>
                                <img 
                                    src={property.images[currentImageIndex[property.id] || 0]} 
                                    alt={property.title}
                                />
                                {property.images.length > 1 && (
                                    <>
                                        <button 
                                            className="prop-carousel-nav prop-carousel-prev"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                prevImage(property.id, property.images.length);
                                            }}
                                        >
                                            <FaChevronLeft />
                                        </button>
                                        <button 
                                            className="prop-carousel-nav prop-carousel-next"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                nextImage(property.id, property.images.length);
                                            }}
                                        >
                                            <FaChevronRight />
                                        </button>
                                        <div className="prop-carousel-dots">
                                            {property.images.map((_, idx) => (
                                                <button
                                                    key={idx}
                                                    className={`prop-dot ${(currentImageIndex[property.id] || 0) === idx ? 'active' : ''}`}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        goToImage(property.id, idx);
                                                    }}
                                                />
                                            ))}
                                        </div>
                                    </>
                                )}
                                
                                {/* Badges */}
                                <div className="prop-card-badges">
                                    {property.featured && <span className="prop-badge prop-badge-featured">Featured</span>}
                                    {property.bestDeal && <span className="prop-badge prop-badge-bestdeal">Best Deal</span>}
                                </div>
                                
                                {/* Like Button */}
                                <button 
                                    className={`prop-like-btn ${likedProperties.includes(property.id) ? 'liked' : ''}`}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        toggleLike(property.id);
                                    }}
                                >
                                    {likedProperties.includes(property.id) ? <FaHeart /> : <FaRegHeart />}
                                </button>
                            </div>
                            
                            <div className="prop-card-content">
                                <div className="prop-card-header">
                                    <div>
                                        <h3>{property.title}</h3>
                                        <div className="prop-location-info">
                                            <FaMapMarkerAlt />
                                            <span>{property.location}</span>
                                        </div>
                                    </div>
                                    <div className="prop-rating">
                                        <FaStar />
                                        <span>{property.rating}</span>
                                    </div>
                                </div>
                                
                                <div className="prop-specs">
                                    <div className="prop-spec">
                                        <FaBed />
                                        <span>{property.bedrooms} Beds</span>
                                    </div>
                                    <div className="prop-spec">
                                        <FaBath />
                                        <span>{property.bathrooms} Baths</span>
                                    </div>
                                    <div className="prop-spec">
                                        <FaRulerCombined />
                                        <span>{property.area}</span>
                                    </div>
                                </div>
                                
                                <div className="prop-amenities">
                                    {property.amenities.slice(0, 6).map((amenity, idx) => (
                                        <span key={idx} className="prop-amenity-tag">{amenity}</span>
                                    ))}
                                    {property.amenities.length > 6 && (
                                        <span className="prop-amenity-tag prop-amenity-more">+{property.amenities.length - 6}</span>
                                    )}
                                </div>
                                
                                <div className="prop-card-actions">
                                    <button className="prop-action-btn prop-action-whatsapp" onClick={() => handleWhatsAppInquiry(property)}>
                                        <FaWhatsapp />
                                        <span>Book Now</span>
                                    </button>
                                    <button className="prop-action-btn prop-action-call" onClick={handleCallInquiry}>
                                        <FaPhoneAlt />
                                        <span>Call Now</span>
                                    </button>
                                    <button className="prop-action-btn prop-action-details" onClick={() => goToPropertyPage(property.id)}>
                                        <span>Details</span>
                                        <FaArrowRight />
                                    </button>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default PropertyPage;